import React from "react"
import Select from "react-select"
import { Input, Col, Label, Row } from "reactstrap"
import "react-datepicker/dist/react-datepicker.css"
import ReactDatePicker from "react-datepicker"
import { customStylesSelect } from "common/data/settings"

// Define a default UI for filtering
const ManageTeamFilter = props => {
  const {
    teamList,
    selectedMainCategory,
    categoryFilter,
    filtersubCategory,
    selectedSubcategory,
    subcategoryFilter,
    reportfilter,
    selectedReport,
    selectedUserData,
    userListFilter,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    activeTab,
    selectedSupervisor,
    supervisorfilter,
    setsupervised,
    supervised,
    setreported,
    reported,
    companySetting,
  } = props

  const startDateChange = date => {
    setStartDate(date)
  }
  const endDateChange = date => {
    setEndDate(date)
  }

  function SortArray(x, y) {
    if (x.name < y.name) {
      return -1
    }
    if (x.name > y.name) {
      return 1
    }
    return 0
  }
  function SortReport(x, y) {
    if (x.userName < y.userName) {
      return -1
    }
    if (x.userName > y.userName) {
      return 1
    }
    return 0
  }
  const maincategory = teamList?.categoryLookup.sort(SortArray)
  const subCategory = filtersubCategory?.sort(SortArray)
  const reportTo = teamList?.reportToLookup?.sort(SortReport)
  const userList = teamList?.teamMemberLookup?.sort(SortReport)
  const supervisor = teamList?.supervisorLookup?.sort(SortReport)

  return (
    <React.Fragment>
      <Col md="12" className="mt-2 mb-2">
        <Row>
          <Col md="3">
            <div>
              <Label htmlFor="formrow-state-Input">
                {companySetting.MainCategory}
              </Label>
              <Select
                isClearable
                className="mb-2"
                value={selectedMainCategory}
                onChange={value => categoryFilter(value)}
                options={maincategory?.map(el => ({
                  ...el,
                  label: el.name,
                  value: el.id,
                }))}
                classNamePrefix="select2-selection"
                styles={customStylesSelect}
              />
            </div>
          </Col>

          <Col md="3">
            <div>
              <Label htmlFor="formrow-state-Input">
                {companySetting.SubCategory}
              </Label>
              <Select
                isClearable
                value={selectedSubcategory}
                className="mb-2"
                onChange={value => subcategoryFilter(value)}
                options={subCategory?.map(el => ({
                  ...el,
                  label: el.name,
                  value: el.name,
                }))}
                classNamePrefix="select2-selection"
                styles={customStylesSelect}
              />
            </div>
          </Col>
          {activeTab === "2" || activeTab === "1" ? (
            ""
          ) : (
            <Col md="3">
              <div>
                <Label htmlFor="formrow-state-Input">Report To</Label>
                <Select
                  isClearable
                  value={selectedReport}
                  onChange={value => reportfilter(value)}
                  className="mb-2"
                  options={reportTo?.map(el => ({
                    ...el,
                    label: el.userName,
                    value: el.userId,
                  }))}
                  classNamePrefix="select2-selection"
                  styles={customStylesSelect}
                />
              </div>
            </Col>
          )}
          {activeTab !== "3" && (
            <Col md="3">
              <div>
                <Label htmlFor="formrow-state-Input">User</Label>
                <Select
                  isMulti
                  isClearable
                  value={selectedUserData}
                  closeMenuOnSelect={false}
                  className="mb-2"
                  onChange={value => userListFilter(value)}
                  options={userList?.map(el => ({
                    ...el,
                    label: el.userName,
                    value: el.userId,
                  }))}
                  classNamePrefix="select2-selection"
                  styles={customStylesSelect}
                />
              </div>
            </Col>
          )}
          {activeTab !== "2" ? (
            <Col md="3">
              <div>
                <Label htmlFor="formrow-state-Input">Supervisor</Label>
                <Select
                  isClearable
                  value={selectedSupervisor}
                  onChange={value => supervisorfilter(value)}
                  options={supervisor?.map(el => ({
                    ...el,
                    label: el.userName,
                    value: el.userId,
                  }))}
                  classNamePrefix="select2-selection"
                  styles={customStylesSelect}
                />
              </div>
            </Col>
          ) : (
            ""
          )}
        </Row>
        <Row className="pt-2 d-flex">
          {activeTab === "3" && (
            <Col md="3">
              <div>
                <Label htmlFor="formrow-state-Input">User</Label>
                <Select
                  isMulti
                  isClearable
                  value={selectedUserData}
                  closeMenuOnSelect={false}
                  onChange={value => userListFilter(value)}
                  options={userList?.map(el => ({
                    ...el,
                    label: el.userName,
                    value: el.userId,
                  }))}
                  classNamePrefix="select2-selection"
                  styles={customStylesSelect}
                />
              </div>
            </Col>
          )}
          <Col md="3">
            <div>
              <Label htmlFor="formrow-state-Input">Start Date</Label>
              <ReactDatePicker
                wrapperClassName="datePicker"
                dateFormat="yyyy-MM-dd"
                selected={startDate}
                onChange={startDateChange}
                className="form-control mb-0 date-icon-back"
                placeholderText="Select date"
              />
            </div>
          </Col>
          <Col md="3">
            <div>
              <Label htmlFor="formrow-state-Input" className="create_team_top">
                End Date
              </Label>

              <ReactDatePicker
                wrapperClassName="datePicker"
                dateFormat="yyyy-MM-dd"
                selected={endDate}
                onChange={setEndDate}
                className="form-control mb-0 date-icon-back"
                placeholderText="Select date"
                minDate={new Date()}
              />
            </div>
          </Col>
          {activeTab === "2" && (
            <>
              <Col md="2" className="d-flex">
                <div className="form-check mt-4 pt-3 me-2">
                  <Input
                    className="form-check-input"
                    type="checkbox"
                    id="supervised"
                    onChange={value => setsupervised(value?.target?.checked)}
                    defaultChecked={supervised}
                  />

                  <Label className="form-check-label" htmlFor="supervised">
                    Supervised
                  </Label>
                </div>
                <div className="form-check mt-4 pt-3 me-2">
                  <Input
                    className="form-check-input"
                    type="checkbox"
                    id="reported"
                    onChange={value => setreported(value?.target?.checked)}
                    defaultChecked={reported}
                  />
                  <Label className="form-check-label" htmlFor="reported">
                    Reported
                  </Label>
                </div>
              </Col>
              {/* <Col md="2">
                  <div className="form-check mt-4 pt-2">
                    <Input
                      className="form-check-input"
                      type="checkbox"
                      id="reported"
                      onChange={value => setreported(value?.target?.checked)}
                      defaultChecked={reported}
                    />
                    <Label className="form-check-label" htmlFor="reported">
                      Reported
                    </Label>
                  </div>
                </Col> */}
            </>
          )}
        </Row>
        {/* </Row> */}
      </Col>
    </React.Fragment>
  )
}

export default ManageTeamFilter
